import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WavySectionComponent } from "./wavy-section.component";

@NgModule({
  declarations: [WavySectionComponent],
  imports: [CommonModule],
  exports: [WavySectionComponent],
})
export class WavySectionModule {}
